import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'images': [],
  'loading': false,
};

const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};

const convertBase64ToFiles = (attachments) => {
  const files = [];
  attachments.forEach(async(item) => {
    const base64 = `data:image/jpeg;base64,${item.file}`;
    return await urltoFile(base64, item.name, item.mimetype).then((file) => files.push(file));
  });
  return files;
};

export const warrantyImages = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TWC_WARRANTY_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_ATTACHMENTS]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'images': convertBase64ToFiles(action.response.data),
        'rawImages': action.response.data,
      };
    },
    [ActionTypes.FETCHED_TWC_WARRANTY_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'images': [],
    }),
  })(state, action);
};
